<template>
  <div class="table-container have-zoom">
    <div class="addparthers">
      <h1>添加合作伙伴</h1>
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="投放活动">
          <!-- <el-input v-model="form.type" placeholder="投放的活动"></el-input> -->
          <el-radio-group v-model="form.type">
            <el-radio
              v-for="(itm,idx) in $env.ARTICLE_LIST"
              :label="itm.value"
              :key="idx"
            >{{itm.name}}</el-radio>
            <!-- <el-radio label="freetalks">汇说</el-radio>
            <el-radio label="hkstocks">决战港股</el-radio>
            <el-radio label="roadshow">汇路演</el-radio>-->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动城市">
          <el-input v-model="form.city" placeholder="活动具体城市"></el-input>
        </el-form-item>
        <el-form-item label="合作伙伴">
          <el-input v-model="form.name" placeholder="合作伙伴名称"></el-input>
        </el-form-item>
        <el-form-item label="合作伙伴链接">
          <el-input v-model="form.link" placeholder="伙伴链接"></el-input>
        </el-form-item>
        <el-form-item label="合作伙伴图片PC">
          <el-upload
            :action="oss.host"
            :data="oss"
            class="one-line-upload"
            :on-success="pcImgUrlSuccess"
            :on-remove="pcImgUrlRemove"
          >
            <el-button size="small" type="primary">
              上传合作伙伴图片
              <i class="el-icon-upload el-icon--right"></i>
            </el-button>
          </el-upload>
          <el-input v-model="form.pcImgUrl" placeholder="上传图片或者粘贴图片链接"/>
        </el-form-item>
        <el-form-item label="合作伙伴图片MB">
          <el-upload
            :action="oss.host"
            :data="oss"
            class="one-line-upload"
            :on-success="mbImgUrlSuccess"
            :on-remove="mbImgUrlRemove"
          >
            <el-button size="small" type="primary">
              上传合作伙伴图片
              <i class="el-icon-upload el-icon--right"></i>
            </el-button>
          </el-upload>
          <el-input v-model="form.mbImgUrl" placeholder="上传图片或者粘贴图片链接"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="pushData" v-if="!id">添加合作伙伴</el-button>
          <el-button type="primary" @click="putData" plain v-if="id">更新合作伙伴信息</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        title: null,
        city: null,
        type: null,
        pcImgUrl: null,
        mbImgUrl: null,
        name: null,
        link: null
      },
      oss: {
        key: "",
        OSSAccessKeyId: "",
        policy: "",
        Signature: "",
        host: "",
        success_action_status: 200,
        callback: ""
      }
    };
  },
  watch: {
    id() {
      this.getData();
    }
  },
  methods: {
    pcImgUrlSuccess(res, file, filelist) {
      if (res.statusCode === 200) {
        this.form.pcImgUrl = `${this.oss.host}/${res.result.filename}`;
      } else {
        this.$message({
          type: "error",
          message: "上传失败"
        });
      }
    },
    mbImgUrlSuccess(res, file, filelist) {
      if (res.statusCode === 200) {
        this.form.mbImgUrl = `${this.oss.host}/${res.result.filename}`;
      } else {
        this.$message({
          type: "error",
          message: "上传失败"
        });
      }
    },
    pcImgUrlRemove() {
      this.form.pcImgUrl = null;
    },
    mbImgUrlRemove() {
      this.form.mbImgUrl = null;
    },
    getOssSign() {
      this.$http.oss_sign().then(res => {
        if (res.data.statusCode === 200) {
          this.oss.host = res.data.result.host;
          this.oss.key =
            res.data.result.dirPath + res.data.result.key + "${filename}";
          this.oss.policy = res.data.result.policy;
          this.oss.OSSAccessKeyId = res.data.result.OSSAccessKeyId;
          this.oss.Signature = res.data.result.Signature;
          this.oss.callback = res.data.result.callback;
        } else {
          this.$message({
            type: "error",
            message: "获取oss签名信息失败,请刷新重试。"
          });
        }
      });
    },
    getData(id) {
      this.$http.parthers_detail(id).then(res => {
        if (res.data.statusCode === 200) {
          const {
            pcImgUrl,
            mbImgUrl,
            city,
            type,
            name,
            link
          } = res.data.result;
          this.form.city = city;
          this.form.type = type;
          this.form.pcImgUrl = pcImgUrl;
          this.form.mbImgUrl = mbImgUrl;
          this.form.name = name;
          this.form.link = link;
        } else {
          this.form.city = null;
          this.form.type = null;
          this.form.pcImgUrl = null;
          this.form.mbImgUrl = null;
          this.form.name = null;
          this.form.link = null;
        }
      });
    },
    pushData() {
      this.$http
        .put_parthers({
          ...this.form
        })
        .then(res => {
          if (res.data.statusCode === 200) {
            this.$router.push("/parthers/list");
            this.$message({
              message: "合作伙伴添加成功~",
              type: "success"
            });
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    putData() {
      this.$http
        .put_parthers({
          id: this.id,
          ...this.form
        })
        .then(res => {
          if (res.data.statusCode === 200) {
            this.$router.push("/parthers/list");
            this.$message({
              message: "合作伙伴信息更新成功~",
              type: "success"
            });
          } else {
            this.$message.error(res.data.message);
          }
        });
    }
  },
  mounted() {
    this.getOssSign();
    if (this.id) {
      this.getData(this.id);
    }
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  }
};
</script>

<style scoped>
.one-line-upload {
  display: inline-block;
  vertical-align: top;
}

.table-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.addparthers {
  width: 700px;
}

.parthershows {
  width: 700px;
  margin-right: 100px;
  background-color: rgb(242, 242, 242);
}
</style>



// WEBPACK FOOTER //
// src/components/backend/parthers-post.vue